<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
          <Button
            v-if="getUserPermission('CREATE_GROUP_CUSTOMER')"
            :label="$t('Add')"
            size="md"
            @click="goToAddGroupCustomer"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="groupCustomerInfoRef"
      :items="customerList"
      responsive
      :busy="isBusy"
      :per-page="pageSize"
      :current-page="currentPage"
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>

      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <template #cell(dateCreated)="data">
        {{ toDateWithYear(data.value) }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="getUserPermission('MODIFY_GROUP_CUSTOMER')"
              @click="goToEditGroupCustomer(data.item, $event.target, 'edit')"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Modify') }}</span>
            </b-dropdown-item>
            <b-dropdown-item @click="onViewGroupCustomer(data.item, $event.target)">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">{{ $t('View') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      :ok-title="$t('Cancel')"
      ok-only
      :cancel-title="$t('Cancel')"
      ok-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Group Customer Information')"
    >
      <b-tabs>
        <b-tab
          :title="$t('Corporate/Group Information')"
          active
        >
          <b-row class="match-height">
            <b-col md="6">
              <InputField
                id="group-type"
                v-model="groupCustomerInfo.customerType"
                :label="$t('Customer Group Type')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Customer ID -->
            <b-col md="6">
              <InputField
                id="customer-id"
                v-model="groupCustomerInfo.customerID"
                :label="$t('Customer ID')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Customer ID -->

            <!--Name -->
            <b-col md="6">
              <InputField
                id="name"
                v-model="groupCustomerInfo.name"
                :label="$t('Name')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Name -->
            <!--Alias -->
            <b-col md="6">
              <InputField
                id="alias"
                v-model="groupCustomerInfo.alias"
                :label="$t('Alias')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Alias -->
          </b-row>
          <b-row>
            <!-- Business Phone Number -->
            <b-col md="6">
              <InputField
                id="business-phone-number"
                v-model="groupCustomerInfo.businessPhoneNumber"
                :label="$t('Business Phone Number')"
                type="number"
                readonly
              />
            </b-col>
            <!-- Business Phone Number -->

            <!-- Notification Phone Number -->
            <b-col md="6">
              <TextAreaField
                id="notification-phone-number"
                v-model="groupCustomerInfo.notificationPhoneNumber"
                :label="$t('Notification Phone Number')"
                type="text"
                for="notification-phone-number"
                rows="2"
                readonly
              />
            </b-col>
            <!-- Notification Phone Number -->
            <!-- Email -->
            <b-col md="6">
              <InputField
                id="email"
                v-model="groupCustomerInfo.email"
                :label="$t('Email')"
                type="email"
                for="email"
                readonly
              />
            </b-col>
            <!--  Email -->

            <!-- Notification Email -->
            <b-col md="6">
              <TextAreaField
                id="notificationEmail"
                v-model="groupCustomerInfo.notificationEmail"
                :label="$t('Notification Email')"
                type="text"
                rows="2"
                readonly
              />
            </b-col>
            <!--  Email -->
          </b-row>
          <b-row>

            <!-- Nature Of Business -->
            <b-col md="6">
              <InputField
                id="nature-of-business"
                v-model="groupCustomerInfo.natureOfBusiness"
                :label="$t('Nature Of Business')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Nature Of Business -->

            <!-- Industrial Sector -->
            <b-col md="6">
              <InputField
                id="industrial-sector"
                v-model="groupCustomerInfo.industrialSector"
                :label="$t('Industrial Sector')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Industrial Sector -->

            <!-- Registration Date -->
            <b-col md="6">
              <InputField
                id="registration-date"
                v-model="groupCustomerInfo.registrationDate"
                :label="$t('Registration Date')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Registration Date -->

            <!-- Incorporation Date -->
            <b-col md="6">
              <InputField
                id="incorporation-date"
                v-model="groupCustomerInfo.incorporationDate"
                :label="$t('Incorporation Date')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Incorporation Date -->

            <!-- Registration Number -->
            <b-col md="6">
              <InputField
                id="registration-number"
                v-model="groupCustomerInfo.registrationNumber"
                :label="$t('Registration Number')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Registration Number -->

            <!-- Contact Person Name -->
            <b-col md="6">
              <InputField
                id="contact-person-name"
                v-model="groupCustomerInfo.contactPersonName"
                :label="$t('Contact Person Name')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Contact Person Name -->

            <!-- Contact Person PhoneNumber -->
            <b-col md="6">
              <InputField
                id="contact-person-phone-no"
                v-model="groupCustomerInfo.contactPersonPhoneNumber"
                :label="$t('Contact Person Phone Number')"
                type="text"
                readonly
              />
            </b-col>
            <!--  Contact Person PhoneNumber -->

            <!-- Country Of Operation -->
            <b-col md="6">
              <InputField
                id="country-of-operation"
                v-model="groupCustomerInfo.countryOfOperation"
                :label="$t('Country of Operation')"
                type="text"
                readonly
              />
            </b-col>
            <!-- Country Of Operation -->

            <!--  State Of Operation -->
            <b-col md="6">
              <InputField
                id="state-of-operation"
                v-model="groupCustomerInfo.stateOfOperation"
                :label="$t('State of Operation')"
                type="text"
                readonly
              />
            </b-col>
            <!--  State Of Operation -->

            <!-- LGA -->
            <b-col md="6">
              <InputField
                id="lga"
                v-model="groupCustomerInfo.lga"
                :label="$t('LGA')"
                type="text"
                for="lga"
                readonly
              />
            </b-col>
            <!--  LGA -->

            <!-- TIN -->
            <b-col md="6">
              <InputField
                id="tin"
                v-model="groupCustomerInfo.tin"
                :label="$t('TIN')"
                type="text"
                for="tin"
                readonly
              />
            </b-col>
            <!--  TIN -->

            <!--  Old customer ID -->
            <b-col md="6">
              <InputField
                id="reference-number"
                v-model="groupCustomerInfo.oldCustomerID"
                :label="$t('Old customer ID')"
                type="text"
                show-icon
                readonly
              />
            </b-col>
            <!--  Old customer ID -->

            <!--  Description -->
            <b-col md="12">
              <TextAreaField
                id="description"
                v-model="groupCustomerInfo.description"
                :label="$t('Description')"
                rows="3"
                readonly
              />
            </b-col>
            <!--  Description -->

            <!--  Official Address -->
            <b-col md="12">
              <TextAreaField
                id="official-address"
                v-model="groupCustomerInfo.address"
                :label="$t('Official Address')"
                rows="3"
                readonly
              />
            </b-col>
          </b-row>
          <!--  Official Address -->
        </b-tab>
        <b-tab
          :title="$t('Signatories')"
        >
          <b-table
            ref="customerListTable"
            :items="signatories"
            :busy="isModalTableBusy"
            responsive
            :fields="translatedSignatoriesHeader"
            primary-key="id"
            show-empty
            :empty-text="$t('No data available')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
          >

            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>

            <template #cell(lastName)="data">
              {{ `${data.item.lastName} ${data.item.firstName} ${data.item.otherNames} ` }}
            </template>
            <template #cell(dateOfBirth)="data">
              {{ toDateWithYear(data.value) }}
            </template>
          </b-table>

          <TablePagination
            v-model="current"
            :from="modalFrom"
            :to="modalTo"
            :total-rows="totalModalEntries"
            :per-page="page"
          />
        </b-tab>
        <b-tab
          v-if="groupLendingConnectionList.length"
          :title="$t('Group Lending')"
        >
          <b-table
            ref="groupLendingRef"
            :items="groupLendingConnectionList"
            responsive
            :fields="translatedTableHeadersGroupCustomerAccount"
            primary-key="id"
            show-empty
            :empty-text="$t('No data available')"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative"
          >
            <template #cell(SN)="data">
              {{ data.index + 1 }}
            </template>
          </b-table>
        </b-tab>
        <b-tab :title="$t('Other Documents')">
          <!-- <b-row class="match-height"> -->
          <b-form>
            <b-row
              v-for="(item, index) in documentsFormData"
              :id="index"
              :key="index"
              class="mb-2 match-height"
            >
              <b-col md="6">
                <SelectField
                  id="document-type"
                  v-model="item.type"
                  :reduce="option => option.value"
                  :label="$t('Document Type')"
                  :placeholder="$t('Select')"
                  :options="translatedDocumentTypeOptions"
                  item="label"
                  readonly
                />
              </b-col>
              <b-col
                md="7"
              >
                <label>{{ $t('Upload Documents') }}</label>

                <div class="upload-image">
                  <b-form-group>
                    <b-form-file
                      :placeholder="$t('Choose a file or drop it here...')"
                      :drop-placeholder="$t('Drop file here...')"
                      accept="image/jpeg, image/png, image/jpg, application/pdf, .doc, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      plain
                      disabled
                      @change="onDocumentsUpload(index, $event)"
                    />
                    <div
                      v-if="!item.url"
                      class="upload-instruction"
                    >
                      <h4>{{ $t('Upload Document File') }}</h4>
                      <p>{{ $t('Drag & drop file or choose from your device to upload') }}</p>
                      <p class="format"> {{ $t('Format accepted (jpg, png, bmp, jpeg, docx, pdf)') }}

                      </p>
                    </div>
                    <div v-else>
                      <div v-if="item.fileExtension === 'png'|| item.fileExtension === 'jpeg'|| item.fileExtension === 'jpg'|| item.fileExtension === 'bmp'">
                        <b-img
                          :src="item.url"
                          block
                          rounded
                          width="250px"
                          height="250px"
                        />
                      </div>
                      <div
                        v-else-if="item.fileExtension === 'pdf'"
                      >
                        <b-img
                          :src="pdfIcon"
                          block
                          rounded
                          width="250px"
                          height="250px"
                        />
                      </div>
                      <div
                        v-else-if="item.fileExtension === 'vnd'"
                      >
                        <b-img
                          :src="wordIcon"
                          block
                          rounded
                          width="250px"
                          height="250px"
                        />
                      </div>
                      <div
                        v-else
                      >
                        <b-img
                          src=""
                        />
                      </div>
                      <div
                        v-if="item.url"
                        class="view-details"
                      >
                        <feather-icon
                          icon="EyeIcon"
                          size="20"
                          class="text-primary"
                          @click="viewDocumentFile(item.url, item.fileName, item.fileExtension)"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <b-col
                md="3"
                class="mt-0"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="ml-0"
                  @click="handleDownload(item.url)"
                >
                  <feather-icon
                    icon="DownloadIcon"
                    class="mr-25"
                  />
                  <span>{{ $t('Download') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      centered
      size="lg"
      :title="$t('Filters')"
      modal-footer
      @ok="fetchGroupCustomer"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Customer ID -->
        <b-col md="6">
          <InputField
            id="customer-id"
            v-model="filter.customerID"
            :label="$t('Customer ID')"
            :placeholder="$t('Enter customer ID')"
            type="text"
          />
        </b-col>
        <!-- Customer ID -->

        <!-- Reference ID -->
        <b-col md="6">
          <InputField
            id="reference-id"
            v-model="filter.oldCustomerID"
            :label="$t('Reference ID')"
            :placeholder="$t('Enter Reference ID')"
            type="text"
            for="reference-id"
          />
        </b-col>
        <!--Reference ID -->

        <!-- Name -->
        <b-col md="6">
          <InputField
            id="name"
            v-model="filter.name"
            :label="$t('Name')"
            :placeholder="$t('Enter name')"
            type="text"
          />
        </b-col>
        <!-- Name -->
        <b-col md="6">
          <SelectField
            id="customer-type"
            v-model="filter.customerType"
            :label="$t('Customer Type')"
            :options="translatedCustomerTypeOptions"
            item="label"
            :reduce="option => option"
            :placeholder="$t('Select')"
          />
        </b-col>

        <!-- Contact Person -->
        <b-col md="6">
          <InputField
            id="contact-person"
            v-model="filter.contactPerson"
            :label="$t('Name')"
            :placeholder="$t('Enter contact person')"
            type="text"
          />
        </b-col>
        <!-- Contact Person -->

        <!-- PhoneNumber -->
        <b-col md="6">
          <InputField
            id="phone-number"
            v-model="filter.phoneNumber"
            :label="$t('Phone Number')"
            :placeholder="$t('Enter phone number')"
            type="number"
          />
        </b-col>
        <!-- PhoneNumber -->

        <!-- Business Phone Number -->
        <b-col md="6">
          <InputField
            id="phone-number"
            v-model="filter.businessPhoneNumber"
            :label="$t('Business Phone Number')"
            :placeholder="$t('Enter business phone number')"
            type="number"
          />
        </b-col>
        <!-- Business Phone Number -->

        <!-- Email -->
        <b-col md="6">
          <InputField
            id="email"
            v-model="filter.email"
            :label="$t('Email')"
            :placeholder="$t('Enter email')"
            rules="email"
            :error-name="$t('Email')"
            type="email"
          />
        </b-col>
        <!-- Email -->

        <!--  Country of Operation -->
        <b-col md="6">
          <SelectField
            id="country-of-operation"
            v-model="filter.countryOfOperation"
            :label="$t('Country of Operation')"
            :options="countryOptions"
            :reduce="option => option"
            item="label"
            :placeholder="$t('Select')"
          />
        </b-col>
        <!--  Country of Operation-->
      </b-row>
    </b-modal>
    <!-- Filter modal -->
    <b-modal
      id="view-avatar-modal"
      ref="avatarModal"
      no-close-on-backdrop
      :ok-title="$t('Download File')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="viewDocumentModalTitle"
      @hidden="resetDocumentModal"
      @cancel="resetDocumentModal"
      @ok="handleDownload(viewDocumentData)"
    >
      <div class="m-2 text-center">
        <b-row>
          <b-col cols="12">
            <div v-if="fileExtension === 'png'|| fileExtension === 'jpeg'|| fileExtension === 'jpg'">
              <b-img
                :src="viewDocumentData"
                block
                fluid
                rounded
              />
            </div>
            <div v-else-if="fileExtension === 'pdf'">
              <b-img
                :src="pdfIcon"
                block
                width="250px"
                height="250px"
                rounded
              />
            </div>
            <div v-else-if="fileExtension === 'vnd'">
              <b-img
                :src="wordIcon"
                block
                width="250px"
                height="250px"
                rounded
              />
            </div>
            <div v-else>
              <b-img
                src=""
              /></div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <FullScreenSpinner :show="showSpinner" />

  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BTabs, BTab,
  BDropdown, BDropdownItem, BModal, BSpinner, BFormGroup, BFormFile, BForm, BImg,
  BButton,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import Button from '../../../../components/button/Button.vue'
import { pdfIcon, wordIcon } from '../../../../../helpers/data'
import { toDateWithYear } from '../../../../../helpers/formatDate'
import TextAreaField from '../../../../forms/TextAreaField.vue'
import { accountPermissions } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BSpinner,
    BTable,
    BDropdown,
    BDropdownItem,
    BTabs,
    BTab,
    TablePagination,
    BModal,
    TableEntries,
    InputField,
    SelectField,
    TextAreaField,
    FullScreenSpinner,
    Button,
    BFormGroup,
    BFormFile,
    BForm,
    BImg,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      sortBy: 'customerID',
      isBusy: false,
      required,
      sortDesc: false,
      signatories: [],
      signatoriesHeader: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'lastName', sortable: true, label: 'name' },
        { key: 'phoneNumber', sortable: true, label: 'Phone Number' },
        { key: 'email', sortable: true, label: 'Email' },
      ],
      tableHeadersGroupCustomerAccount: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'productName', sortable: true, label: 'Product Number' },
      ],
      groupLendingConnectionList: [],
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'name', sortable: true, label: 'Name' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'businessPhoneNumber', sortable: true, label: 'Phone Number' },
        { key: 'email', sortable: true, label: 'Email' },
        { key: 'contactPersonPhoneNumber', sortable: true, label: 'Contact Person Phone Number' },
        { key: 'customerType', sortable: true, label: 'Customer Type' },
        { key: 'countryOfOperation', sortable: true, label: 'Country of Operation' },
        { key: 'oldCustomerID', sortable: true, label: 'Reference ID' },
        { key: 'dateCreated', sortable: true, label: 'Date Created' },
        { key: 'actions', label: 'Actions' },
      ],
      filter: {
        customerID: null,
        oldCustomerID: null,
        name: null,
        customerType: null,
        phoneNumber: null,
        businessPhoneNumber: null,
        email: null,
        contactPerson: null,
        countryOfOperation: null,
        sortColumn: null,
        direction: null,
      },
      groupCustomerInfo: {
        customerID: '',
        customerType: '',
        name: '',
        alias: '',
        description: '',
        address: '',
        businessPhoneNumber: '',
        notificationPhoneNumber: '',
        natureOfBusiness: '',
        industrialSector: '',
        registrationDate: '',
        incorporationDate: '',
        registrationNumber: '',
        email: '',
        notificationEmail: '',
        contactPersonName: '',
        contactPersonPhoneNumber: '',
        countryOfOperation: '',
        stateOfOperation: '',
        lga: '',
        tin: '',
        oldCustomerID: '',
      },
      customerList: [],
      customerCache: {}, // { [cacheKey]: { data: [], totalCount: number } }
      cacheStale: false,
      customerTypeOptions: [
        { label: 'Corporate', value: 'Corporate' },
        { label: 'Group', value: 'Group' },
      ],
      countryOptions: [],
      pdfIcon,
      wordIcon,
      documentsFormData: [{
        type: '',
        url: '',
        file: '',
      }],
      viewDocumentData: '',
      viewDocumentModalTitle: '',
      fileExtension: '',
      documentTypeOptions: [
        { value: 1, label: 'Signature Specimen' },
        { value: 2, label: 'Proof Of Address' },
        { value: 3, label: 'Driver’s License' },
        { value: 4, label: 'National Identity Card' },
        { value: 5, label: 'Voters Card' },
        { value: 6, label: 'National Identity Number' },
        { value: 7, label: 'International Passport' },
        { value: 8, label: 'Passport Photograph' },
        { value: 9, label: 'Reference Letter' },
        { value: 10, label: 'Guarantor’s Letter' },
        { value: 11, label: 'Loan Application Form' },
        { value: 12, label: 'Credit Bureau Form' },
        { value: 13, label: 'Others' },
      ],
      documentIdentifier: '',
    }
  },
  computed: {
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedSignatoriesHeader() {
      return this.signatoriesHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedDocumentTypeOptions() {
      return this.documentTypeOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    translatedCustomerTypeOptions() {
      return this.customerTypeOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    translatedTableHeadersGroupCustomerAccount() {
      return this.tableHeadersGroupCustomerAccount.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchGroupCustomer()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchGroupCustomer()
    },
  },
  mounted() {
    this.fetchGroupCustomer()
  },
  methods: {
    ...mapActions({
      getGroupCustomer: 'account/getGroupCustomerList',
      getGroupMembers: 'account/getGroupMembersByGroupId',
      getIndividualCustomerByID: 'account/getCustomer',
    }),
    handleDownload(data) {
      const link = document.createElement('a')
      link.href = data
      link.click()
      this.alertSuccess({ text: 'Your request to download file was successful' })
    },
    viewDocumentFile(image, title, fileExtension) {
      this.fileExtension = fileExtension
      this.viewDocumentData = image
      this.viewDocumentModalTitle = title.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ')
      this.$root.$emit('bv::show::modal', 'view-avatar-modal')
    },
    resetDocumentModal() {
      this.viewDocumentData = ''
      this.viewDocumentModalTitle = ''
    },
    toDateWithYear,
    async fetchGroupCustomer() {
      try {
        this.isBusy = true
        this.hideModal('modal-filter')
        const cacheKey = JSON.stringify({ page: this.currentPage, perPage: this.perPage, filter: this.filter })
        if (!this.cacheStale && this.customerCache[cacheKey]) {
          const cached = this.customerCache[cacheKey]
          this.customerList = cached.data
          this.totalCount = cached.totalCount
          this.isBusy = false
          return
        }
        const response = await this.getGroupCustomer({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
          permission: accountPermissions.VIEW_GROUP_CUSTOMER,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.customerList = data.data
          this.totalCount = data.recordCount
          this.customerCache[cacheKey] = {
            data: data.data,
            totalCount: data.recordCount,
          }
        } else {
          this.customerList = []
          this.totalCount = 0
        }
        this.cacheStale = false
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async onViewGroupCustomer(items) {
      try {
        this.showSpinner = true
        this.isModalTableBusy = true
        const response = await this.getGroupMembers({
          formData: {
            groupCustomerID: items.customerID,
            pageNumber: 0,
            pageSize: 0,
          },
          permission: accountPermissions.VIEW_GROUP_CUSTOMER,
        })
        this.groupCustomerInfo = {
          ...items,
          registrationDate: items.registrationDate ? this.toDateWithYear(items.registrationDate) : null,
          incorporationDate: items.incorporationDate ? this.toDateWithYear(items.incorporationDate) : null,
        }
        this.signatories = response.data.data
        this.recordCount = response.data.recordCount
        this.$root.$emit('bv::show::modal', 'modal-lg')

        const { id } = items
        const responses = await this.getIndividualCustomerByID({ id, permission: accountPermissions.VIEW_GROUP_CUSTOMER })
        const { data, status } = responses
        if (status === 200 && data.data) {
          this.groupLendingConnectionList = responses.data.data.groupLendingConnection || []

          this.documentIdentifier = responses.data.data.documentIdentifier
          this.documentsFormData = responses.data.data.documents ? responses.data.data.documents.map(item => ({
            url: item.url,
            type: item.typeID,
            id: item.id,
            fileName: item.type,
            fileExtension: item.fileExtension,
          })) : [{
            url: '',
            type: '',
          }]
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
        this.isModalTableBusy = false
      }
    },
    goToAddGroupCustomer() {
      this.$router.push({
        name: 'group-customer',
        params: {
          type: 'add',
        },
      }).catch(error => {
        this.alertError({ text: error })
      })
    },
    goToEditGroupCustomer(item, activity, val) {
      this.$router.push({
        name: 'group-customer',
        params: {
          type: val,
          id: item.id,
        },
      }).catch(error => {
        this.alertError({ text: error })
      })
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.cacheStale = true
      this.fetchGroupCustomer()
    },
  },
}
</script>
<style scoped>
.modal-body {
  position: relative;
  flex: 1 1 auto;
  max-height: calc(80vh - 140px) !important;
}
.upload-image{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 250px;
    height: 250px
}
.format {
    color: #999999 !important;
}
form input[type=file]{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
.upload-instruction{
  padding-top: 22%;
  color: #000;
  text-align: center;
}
.view-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
.upload {
  max-width: 100%;
  max-height: 100%;
}
</style>
